module.exports = " <pre>\n  <code class=hljs :class=hljsCode.language>{{{ hljsCode.value }}}</code>\n</pre> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-docs/app/shared/components/AppCode.vue
 ** module id = 255
 ** module chunks = 2
 **/